/**
 * Axios helpers used by drawer forms so API/Celebrate errors can be shown
 * under the matching field instead of in a SweetAlert behind the panel.
 */

export const getApiPayload = (response) => {
  if (!response) return {};
  if (response.response?.data && typeof response.response.data === "object") {
    return response.response.data;
  }
  if (response.data && typeof response.data === "object" && ("code" in response.data || "message" in response.data)) {
    return response.data;
  }
  return response;
};

export const isApiSuccess = (response) => {
  if (!response || response.isAxiosError) return false;
  const payload = getApiPayload(response);
  const code = payload.code ?? response.status ?? response.statusCode;
  return [200, 201].includes(Number(code));
};

export const getApiErrorMessage = (response, fallback = "Please fix the highlighted fields.") => {
  const payload = getApiPayload(response);
  if (typeof payload.message === "string" && payload.message.trim()) return payload.message;
  return fallback;
};

export const getApiFieldErrors = (response, aliases = {}) => {
  const payload = getApiPayload(response);
  const details = payload.errors?.details || payload.details || [];
  const fieldErrors = {};

  if (Array.isArray(details)) {
    details.forEach((item) => {
      if (!item || typeof item === "string") return;
      const rawField = item.field || item.path || "";
      if (!rawField || !item.message) return;
      const field = aliases[rawField] || rawField;
      fieldErrors[field] = item.message;
    });
  }

  return fieldErrors;
};
